import axios from "axios";

export default class Product {
  constructor() {
    this.base_url = process.env.REACT_APP_URL_CATALOG;
    this.name = "/products";
    this.url = this.base_url + this.name;
  }

  grid = async (skip = 0, take = 100, active) => {
    return await axios.get(
      `${this.url}?skip=${skip}&take=${take}&active=${active}`
    );
  };

  getById = async (id) => {
    return await axios.get(`${this.url}/${id}`);
  };

  sku = async () => {
    return await axios.get(`${this.url}/sku`);
  };

  stockV1 = async () => {
    return await axios.get(`${this.url}/stockV1`);
  };

  priceList = async (skip = 0, take = 100, search = "") => {
    return await axios.get(
      `${this.url}/price_list?skip=${skip}&take=${take}&search=${search}`
    );
  };

  priceUpdate = async (body) => {
    return await axios.put(`${this.url}/price_update`, body);
  };

  selectByCategory = async (categoryName) => {
    return await axios.get(`${this.url}/select/category/${categoryName}`);
  };

  select = async ({ search = "", take = 50 } = {}) => {
    const query = new URLSearchParams({ take });
    if (search.trim()) query.set("search", search.trim());
    return await axios.get(`${this.url}/select?${query.toString()}`);
  };

  create = async (data, idempotencyKey) => {
    await axios.post(`${this.url}`, data, {
      headers: { "Idempotency-Key": idempotencyKey },
    });
  };

  update = async (id, data, idempotencyKey) => {
    await axios.put(`${this.url}/${id}`, data, {
      headers: { "Idempotency-Key": idempotencyKey },
    });
  };

  changeActive = async (id, data) => {
    await axios.patch(`${this.url}/${id}`, data);
  };
}
